import React, { Component, Fragment } from "react";
import "./LoginForm.scss";
import LoginFormCard from "../../components/Login/LoginFormCard";
import OtpLoginFormCard from "../../components/Login/OtpLoginFormCard";
import OtpVerifyFormCard from "../../components/Login/OtpVerifyFormCard";
import ForgotPassword from "../../components/Login/ForgotPassword";
import LoginWithSso from "../../components/Login/LoginWithSso";
import { connect } from 'react-redux';
import { SEEKER } from "Constants/commonConstants";
import { SEEKER_VALUE, PROVIDER_VALUE, USER_ID, MOBILE_NO } from 'Constants/commonConstants';
import { SIGN_IN, FORGOT_PASSWORD, REQUEST_OTP, LOGIN_WITH_OTP, VALIDATE_SSO_USER, GET_SSO_CONFIG, TOAST_ERROR } from 'Constants/actionConstants';
import {
  getToken, getCompanyType, setCookie, getUser,
  setCookieV3, getCookieV3
} from 'Utils/storage';
// import { getToken, getCompanyType, setCookie, getUser } from 'Utils/storage';
import { getSecureRandomKey, isRILCompany, isNewDemoCompany } from "Utils/index";
import { SSO_BASE_URL, SSO_URL } from '../../utils/api';
import { ReactComponent as AlertIcon } from './icons/esclamation.svg';
import cx from 'classnames';
import Toast from "Components/Toast/index";
import { ToastContainer, toast } from "react-toastify";
// import { sha256, sha224 } from 'js-sha256';
import ActionLoader from 'Components/ActionLoader/index';
import { getItemFromLocal, setItemToLocal } from "Utils/localStorage";
import CookiePopupCard from "Pages/Common/CookiePopupCard/index";
import CookiePreferencesModal from "Pages/Common/CookiePreferencesModal/index";

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyType: window.location.hostname.includes('provider') ? PROVIDER_VALUE : SEEKER_VALUE,
      isPasswordVisible: false,
      password: "",
      isOtpLogin: false,
      isVerifyOtp: false,
      otp: "",
      isForgotPassword: false,
      isLoginWithSso: false,
      email: "",
      password: "",
      contact_number: null,
      expire_time: null,
      start_time: null,
      hasExpired: false,
      invalidOTP: false,
      invalidContact: false,
      otp: '',
      errorMsg: '',
      isVerified: false,
      isSSOLogin: false,
      forgotPasswordPage: false,
      reCaptchaKey: 1,
      captcha_value: '',
      isOtpSent: false,
      emailOrMobileInput: "",
      show_checkbox: false,
      isUserAlreadyLoggedin: false,
      hideLoginBtn: false,


      errorMessage: "",
      force_logout: false,
      // formType: SIGN_IN_FORM,
      otp_show_checkbox:false,
      urlLink: window.location.href,
      isCookiePreferencesModalOpen : false,
    };
  }

  companyTypeTabButton = [
    {
      id: 1,
      value: "Seeker Login",
    },
    {
      id: 2,
      value: "Provider Login",
    },
  ];

  componentDidMount() {
    const { dispatch } = this.props;
    const token = getToken();
    const isSSOLogin = getUser().isSSOLogin;
    dispatch({
      type: GET_SSO_CONFIG,
      params: {}
    });
    if (window.name && window.name.length > 0 && (!token || (JSON.parse(window.name))['teg-session-token'] !== token) && !(JSON.parse(window.name))['sso-logout-duration']) {
      Object.entries(JSON.parse(window.name)).forEach(([key, value]) => {
        setCookie(key, value, 200);
      });
      window.location.reload();
    } 
    const scriptUrls = [
      'https://cdn.botpress.cloud/webchat/v1/inject.js',
      'https://mediafiles.botpress.cloud/b4782c83-24df-461a-bca6-b64b77437441/webchat/config.js'
    ];

    // Create an array to store the script elements for cleanup
    this.scripts = scriptUrls.map((url, index) => {
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      if (index === 1) {
        script.defer = true; // Add defer for the second script (config.js)
      }
      script.onload = () => {
        console.log(`${url} loaded successfully.`);
      };
      script.onerror = () => {
        console.error(`Error loading script: ${url}`);
      };

      // Append the script to the document body
      document.body.appendChild(script);
      return script;
    });
    if (!token) {
      return;
    } else {
      if (isSSOLogin) {
        localStorage.setItem('teg-component', false);
        localStorage.setItem('sso-session', true);
        localStorage.setItem('isSSOUser', true);
        localStorage.setItem('teg-sso-session', true);
      }
      this.props.history.push(getCompanyType() === SEEKER_VALUE ? ((isRILCompany() || isNewDemoCompany()) ? '/nsr/seeker-home' : '/seeker') : '/transporters')
      // this.props.history.push('/transporters')
    }
      
  }

  selectCompanyType = (companyType) => {
    this.setState({
      companyType,
      isVerified: false,
      reCaptchaKey: getSecureRandomKey()
    });
  };

  handlePasswordChange = (e) => {
    const password = e.target.value;
    this.setState({
      password,
    });
  };
  handleEmailChange = (e) => {
    const email = e.target.value;
    this.setState({
      email,
    });
  };

  handleChangeOtp = (otp) => {
    const numericOtp = otp.replace(/[^0-9]/g, '');
    this.setState({ otp: numericOtp });
  };

  handleEmailOrMobileChange = (e) => {
    const emailOrMobileInput = e.target.value;
    const mobilePattern = /^[0-9]*$/;
    if (mobilePattern.test(emailOrMobileInput)) {
      if (emailOrMobileInput.length <= 10) {
        this.setState({
          emailOrMobileInput,
        });
      }
    } else {
      this.setState({
        emailOrMobileInput,
      });
    }
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      isPasswordVisible: !prevState.isPasswordVisible,
    }));
  };

  toggleOtpLogin = () => {
    this.setState((prevState) => ({
      isOtpLogin: !prevState.isOtpLogin,
      email: "",
      password: ""
    }));
  };

  onClickSendOtp = () => {
    const { emailOrMobileInput, isVerifyOtp } = this.state;
    const {dispatch} = this.props

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const mobilePattern = /^[0-9]{10}$/;

    if (!emailOrMobileInput) {
      toast.error("Enter email address or mobile number");
      return;
    }

    if (emailPattern.test(emailOrMobileInput)) {
      this.setState({ email: emailOrMobileInput, contact_number: '' }, () => {
        this.sendOTP();
      });
    } else if (mobilePattern.test(emailOrMobileInput)) {
      this.setState({ contact_number: emailOrMobileInput, email: '' }, () => {
        this.sendOTP();
      });
    } else {
      toast.error("Please enter a valid email address or mobile number");
    }

  };
  onClickReSendOtp = () => {
    const { emailOrMobileInput, isVerifyOtp } = this.state;

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const mobilePattern = /^[0-9]{10}$/;

    if (emailPattern.test(emailOrMobileInput)) {
      this.setState({ email: emailOrMobileInput, contact_number: '' }, () => {
        this.reSendOTP();
      });
    } else if (mobilePattern.test(emailOrMobileInput)) {
      this.setState({ contact_number: emailOrMobileInput, email: '' }, () => {
        this.reSendOTP();
      });
    }

  };

  backtoSendOtp = () => {
    this.setState((prevState) => ({
      isVerifyOtp: !prevState.isVerifyOtp,
    }));
  }

  toggleForgotPassword = () => {
    this.setState((prevState) => ({
      isForgotPassword: !prevState.isForgotPassword,
      isVerified: false,
      email: "",
      password: "",
      reCaptchaKey: getSecureRandomKey()
    }));
  };

  toggleLoginWithSso = () => {
    this.setState((prevState) => ({
      isLoginWithSso: !prevState.isLoginWithSso,
      isSSOLogin: true,
      email: "",
      password: ""
    }));
  };

  shouldRenderLoginFormCard = () => {
    const {
      isOtpLogin,
      isVerifyOtp,
      isForgotPassword,
      isLoginWithSso,
    } = this.state;

    const C1 = !isOtpLogin;
    const C2 = !isVerifyOtp;
    const C3 = !isForgotPassword;
    const C4 = !isLoginWithSso;

    if (C1 && C2 && C3 && C4) {
      return true;
    }
  };

  shouldRenderOtpLoginFormCard = () => {
    const {
      isOtpLogin,
      isVerifyOtp,
      isForgotPassword,
      isLoginWithSso,
    } = this.state;

    const C1 = isOtpLogin;
    const C2 = !isVerifyOtp;
    const C3 = !isForgotPassword;
    const C4 = !isLoginWithSso;

    if (C1 && C2 && C3 && C4) {
      return true;
    }
  };

  shouldRenderOtpVerifyFormCard = () => {
    const { isVerifyOtp, isForgotPassword, isLoginWithSso } = this.state;

    const C1 = isVerifyOtp;
    const C2 = !isForgotPassword;
    const C3 = !isLoginWithSso;

    if (C1 && C2 && C3) {
      return true;
    }
  };

  shouldRenderForgotPasswordFormCard = () => {
    const { isForgotPassword, isLoginWithSso } = this.state;

    const C1 = isForgotPassword;
    const C2 = !isLoginWithSso;

    if (C1 && C2) {
      return true;
    }
  };

  shouldRenderLoginWithSsoFormCard = () => {
    const { isLoginWithSso } = this.state;

    const C1 = isLoginWithSso;

    if (C1) {
      return true;
    }
  };

  validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  formSubmit = (e, isDirectSSO = false) => {
    const { tabType, otp, isSSOLogin, email, password, companyType, isOtpLoginEnable, formType, isVerified } = this.state;
    const {dispatch} = this.props
    e.preventDefault();
    if (!email || !password) {
      toast.error("Email and password must not be empty!");
      return;
    }
    if (!this.validateEmail(email)) {
      toast.error("Please enter a valid email address!");
      return;
    }
    if (this.shouldEnableRecaptcha() && !isVerified) {
      toast.error("Please complete the CAPTCHA verification.");
      return;
    }
    // this.props.emailPasswordCallback(this.state);
    if(isDirectSSO){
      localStorage.setItem('isSSOUser', true);
      window.location.replace(`${SSO_BASE_URL}${SSO_URL}/?sso&next=${window.location.origin}/seeker`);
    } else {
      this.signin();
    }

    this.setState((prevState) => {
      const updatedState = { ...prevState };
      updatedState.isVerified = false
      updatedState.reCaptchaKey = getSecureRandomKey()
      return updatedState
    })
  }

  sendOTP = () => {
    const { dispatch } = this.props;
    const {
      contact_number,
      companyType,
      captcha_value,
      email,
      isVerifyOtp
    } = this.state;
    dispatch({
      type: REQUEST_OTP,
      data: {
        contact_number: contact_number || undefined,
        company_type: companyType,
        email: email || undefined,
        module_id: 1,
        device_type: 3,
        captcha_value,
      },
      onSuccess: (detail) => {
        this.setState({
          expire_time: detail.expire_time,
          start_time: detail.created_on,
          hasExpired: false,
          invalidOTP: false,
          invalidContact: false,
          otp_show_checkbox: false,
          otp: '',
          isOtpSent: true,
          isVerifyOtp: !isVerifyOtp
        })
      },
      onError: (message) => {
        this.setState({
          invalidContact: true,
          // otp_show_checkbox: true,
          errorMessage: message
        })
      }
    })
  }

  reSendOTP = () => {
    const { dispatch } = this.props;
    const {
      contact_number,
      companyType,
      captcha_value,
      email,
      isVerifyOtp
    } = this.state;
    dispatch({
      type: REQUEST_OTP,
      data: {
        contact_number: contact_number || undefined,
        company_type: companyType,
        email: email || undefined,
        module_id: 1,
        device_type: 3,
        captcha_value,
      },
      onSuccess: (detail) => {
        this.setState({
          expire_time: detail.expire_time,
          start_time: detail.created_on,
          hasExpired: false,
          invalidOTP: false,
          invalidContact: false,
          otp_show_checkbox: false,
          otp: '',
          isOtpSent: true,
          // isVerifyOtp: !isVerifyOtp
        })
      },
      onError: (message) => {
        this.setState({
          invalidContact: true,
          // otp_show_checkbox: true,
          errorMessage: message
        })
      }
    })
  }

  otpSignin = () => {
    const { dispatch } = this.props;
    const { companyType, contact_number, otp,
      captcha_value, email, 
      // forceOtpLogin
    } = this.state;
    dispatch({
      type: LOGIN_WITH_OTP,
      data: {
        contact_number: contact_number || undefined,
        company_type:companyType,
        otp_number: otp,
        email: email || undefined,
        device_type: 3,
        module_id: 1,
        captcha_value,
        // force_logout: forceOtpLogin ? true : false
      },
      onError: (msg) => {
        const isUserAlreadyLoggedin = msg == 1
        const hideLoginBtn = msg == 1
        const isForceLogout = msg == 1
        this.setState({
          invalidOTP: true,
          errorMsg: msg,
          otp_show_checkbox: isForceLogout ? true : undefined,
          forceOtpLogin: isForceLogout,
          isUserAlreadyLoggedin,
          hideLoginBtn
        },);
      }
    })
  }

  forceotpSignin = () => {
    const { dispatch } = this.props;
    const { companyType, contact_number, otp,
      captcha_value, email, forceOtpLogin
    } = this.state;
    dispatch({
      type: LOGIN_WITH_OTP,
      data: {
        contact_number: contact_number || undefined,
        company_type: companyType,
        otp_number: otp,
        email: email || undefined,
        device_type: 3,
        module_id: 1,
        captcha_value,
        force_logout: forceOtpLogin ? true : undefined
      },
      onError: (msg) => {
        const isUserAlreadyLoggedin = msg == 1
        const hideLoginBtn = msg == 1
        const isForceLogout = msg == 1
        this.setState({
          invalidOTP: true,
          errorMsg: msg,
          // otp_show_checkbox: isForceLogout ? true : undefined,
          // forceOtpLogin: isForceLogout,
          isUserAlreadyLoggedin,
          hideLoginBtn
        },);
      }
    })
  }

  otpExpired = () => {
    const { expire_time, start_time } = this.state;
    const systemTime = new Date().getTime();
    if (expire_time && start_time && expire_time < systemTime) {
      this.setState({ hasExpired: true, otp: '' });
    }
    // else {
    //   this.setState({ hasExpired: false });
    // }
  }

  validateSSOUser = () => {
    const { email } = this.state;
    const { dispatch } = this.props;
    if (!email) {
      toast.error("Email must not be empty!");
      return;
    }
    if (!this.validateEmail(email)) {
      toast.error("Please enter a valid email address!");
      return;
    }
    const data = {
      email
    }
    dispatch({
      type: VALIDATE_SSO_USER,
      data,
      onSuccess: () => {
        localStorage.setItem('isSSOUser', true);
        window.location.replace(`${SSO_BASE_URL}${SSO_URL}/?sso&email=${email}&next=${window.location.origin}/seeker`);
      }
    })

  }

  verifyCallback = (response) => {
    const { dispatch} = this.props;
    // dispatch({
    //   type: VALIDATE_RECAPTCHA,
    //   data: {
    //     captcha_value: response
    //   },
    //   onSuccess: (successData) => {
    //     if(successData && successData.success){
    //       this.setState({
    //         isVerified:true
    //       });
    //       this.setState({
    //         errorMessage:""
    //       });
    //     }
    //   }
    // })

    this.setState((prevState) => {
      const updatedState = { ...prevState };
      updatedState.captcha_value = response
      updatedState.isUserAlreadyLoggedin = false;
      updatedState.isVerified = true;
      return updatedState
    })
    // handleSetCaptchaValue(response)
  }

  onExpire = () => {
    this.setState({
      isVerified: false
    });
  };

  forgotPassword = (e) => {
    const { dispatch } = this.props;
    const { email, companyType,
      captcha_value, urlLink, isVerified
    } = this.state;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      toast.error("Email field cannot be empty.");
      return;
    } else if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    if (this.shouldEnableRecaptcha() && !isVerified) {
      toast.error("Please complete the CAPTCHA verification.");
      return;
    }
    dispatch({
      type: FORGOT_PASSWORD,
      data: {
        email,
        companyType,
        module_id:1,
        device_type: 3,
        urlLink: urlLink,
        captcha_value
      }
    })
    this.setState({
      isVerified: false,
      captcha_value: '',
      reCaptchaKey: getSecureRandomKey()
    });
  }

  result = (text) => { this.setState({ actualCaptcha: text }) }

  shouldRenderSelectRecaptchaMsg = () => {
    const { isUserAlreadyLoggedin } = this.props;
    const { isVerified } = this.state;
    const C1 = isUserAlreadyLoggedin && !isVerified

    if (C1) {
      return true;
    }

    return false;
  }

  maskInput = (emailOrMobileInput) => {
    if (/^\d+$/.test(emailOrMobileInput)) {
      return `XXXXXX ${emailOrMobileInput.slice(-4)}`;
    } else if (emailOrMobileInput.includes('@')) {
      const [name, domain] = emailOrMobileInput.split('@');
      const visiblePart = name.slice(0, 2);
      const maskedPart = '*'.repeat(name.length - 2);
      return `${visiblePart}${maskedPart}@${domain}`;
    } else {
      return emailOrMobileInput;
    }
  }

  shouldEnableRecaptcha = () => {
    const { ssoConfigData } = this.props;
    if (!(ssoConfigData || {}).enable_captcha) {
      return false;
    }
    if (getItemFromLocal("rc") === false) {
      return false;
    }
    return true;
  }

  onGenerateAnotherSession = () => {
    const { show_checkbox, invalidContact, invalidOTP } = this.state;
    this.setState({
      show_checkbox: !show_checkbox,
      invalidOTP: !invalidOTP,
      invalidContact: !invalidContact,
      force_logout: true
    }, () => {
      this.signin();
    })
  }


  // navigateToSSO = (e) => {
  //   this.setState({
  //     formType: e.target.getAttribute("name"),
  //     errorMessage: ''
  //   })
  // }

  // getEncryptedPassword = () => {
  //   const { password } = this.state;
  //   const hash = sha256(password)
  //   return hash
  // }

  signin = (e) => {
    const { dispatch } = this.props;
    const { email, password, companyType, force_logout,
      captcha_value, 
      // signInforceOtpLogin
    } = this.state;
    console.log("---in signin---");
    // let enCryPsw = this.getEncryptedPassword()

    dispatch({
      type: SIGN_IN,
      data: {
        email,
        // password: enCryPsw,
        password,
        device_type: 3,
        module_id: 1,
        companyType,
        // force_logout: signInforceOtpLogin ? true : undefined,
        captcha_value
      },
      onError: (data) => {
        const isUserAlreadyLoggedin = data == 1
        const hideLoginBtn = data == 1
        const isForceLogout = data == 1
        this.setState({
          show_checkbox: isForceLogout ? true : undefined,
          isUserAlreadyLoggedin,
          hideLoginBtn,
          signInforceOtpLogin: isForceLogout,
        });
      }
    })
  }
  forceSignIn = (e) => {
    const { dispatch } = this.props;
    const { email, password, companyType, force_logout,
      captcha_value, signInforceOtpLogin
    } = this.state;
    console.log("---in signin---");
    // let enCryPsw = this.getEncryptedPassword()

    dispatch({
      type: SIGN_IN,
      data: {
        email,
        // password: enCryPsw,
        password,
        device_type: 3,
        module_id: 1,
        companyType,
        force_logout: signInforceOtpLogin ? true : undefined,
        captcha_value
      },
      onError: (data) => {
        const isUserAlreadyLoggedin = data == 1
        const hideLoginBtn = data == 1
        const isForceLogout = data == 1
        this.setState({
          // show_checkbox: isForceLogout ? true : undefined,
          isUserAlreadyLoggedin,
          hideLoginBtn,
          // signInforceOtpLogin: isForceLogout,
        });
      }
    })
  }

  shouldRenderCompanyTab = () => {
    if ((window.location.hostname.includes('seeker') ||
      window.location.hostname.includes('provider')) ||
      window.location.hostname.includes('awl')) {
      return false
    }
    return true
  }

  handleOnClickAcceptCookies = () => {
    const data = {
      "ad_personalization": "denied",
      "ad_storage": "denied",
      "ad_user_data": "denied",
      "analytics_storage": "denied",
      "functionality_storage": "denied",
      "personalization_storage": "denied",
      "security_storage": "granted",
      "social_storage": "denied",
      "unclassified_storage": "denied"
    }
    setCookieV3('teg_default_consents',JSON.stringify(data) ,600,".transporteg.com")
    setCookieV3('teg_default_consents_accepted',true ,600,".transporteg.com")
    this.setState(prev => prev)
  }
  handleOnClickPreferences = () => {
    this.setState((prevState) => {
      const updatedState = { ...prevState };
      updatedState.isCookiePreferencesModalOpen = true;
      return updatedState
    })
  }
  handleOnCloseForCookiePreferencesModal = () => {
    this.setState((prevState) => {
      const updatedState = { ...prevState };
      updatedState.isCookiePreferencesModalOpen = false;
      return updatedState
    })
  }

  shouldRenderCookiePopupCard = () => {
    const teg_default_consents_accepted = getCookieV3('teg_default_consents_accepted');
    if (teg_default_consents_accepted === true) {
      return false;
    }
    return true;
  }

  componentWillUnmount() {
    // Cleanup: remove all scripts when the component is unmounted
    if (this.scripts) {
      this.scripts.forEach((script) => {
        document.body.removeChild(script);
      });
    }
  }

  render() {
    const {
      companyType,
      isPasswordVisible,
      password,
      otp,
      start_time,
      expire_time,
      hasExpired,
      invalidOTP,
      contact_number,
      invalidContact,
      errorMessage,
      errorMsg,
      isVerified,
      forgotPasswordPage,
      reCaptchaKey,
      email,
      emailOrMobileInput,
      show_checkbox,
      otp_show_checkbox,
      isUserAlreadyLoggedin,
      isCookiePreferencesModalOpen
    } = this.state;
    // console.log("render state", this.state)
    const {
      error,
      ssoConfigData,
      hideLoginBtn,
      onGenerateAnotherSession,
      isSubmitting
      // show_checkbox
    } = this.props;
    // console.log("render props", this.props)

    const systemTime = new Date().getTime();

    let disableLogin = null;

    if (this.shouldEnableRecaptcha()) {
      disableLogin = !isVerified || (!otp ? (start_time && !hasExpired) : otp.length != 6);   // actual code
    } else {
      disableLogin = (!otp ? (start_time && !hasExpired) : otp.length != 6);  // temp for few days
    }

    // const disableTegLogin = ssoConfigData.disable_teg_login;
    // const isCustomDomain = ssoConfigData.is_custom_domain;

    const maskedInput = this.maskInput(emailOrMobileInput);

    return (
      <div className="loginFormMain">
        {this.shouldRenderCookiePopupCard() &&
          <CookiePopupCard
            handleOnClickAcceptCookies={this.handleOnClickAcceptCookies}
            handleOnClickPreferences = {this.handleOnClickPreferences}
          />}
        {isCookiePreferencesModalOpen && 
         <CookiePreferencesModal 
           onClose = {this.handleOnCloseForCookiePreferencesModal}
        />}
        {isSubmitting && <ActionLoader />}
        {this.shouldRenderLoginFormCard() && (
          <LoginFormCard
            companyTypeTabButton={this.companyTypeTabButton}
            companyType={companyType}
            selectCompanyType={this.selectCompanyType}
            isPasswordVisible={isPasswordVisible}
            togglePasswordVisibility={this.togglePasswordVisibility}
            handlePasswordChange={this.handlePasswordChange}
            password={password}
            toggleOtpLogin={this.toggleOtpLogin}
            toggleForgotPassword={this.toggleForgotPassword}
            toggleLoginWithSso={this.toggleLoginWithSso}
            handleEmailChange={this.handleEmailChange}
            email={email}
            onSubmit={this.formSubmit}
            shouldRenderCompanyTab={this.shouldRenderCompanyTab}
            shouldEnableRecaptcha={this.shouldEnableRecaptcha}
            verifyCallback={this.verifyCallback}
            onExpire={this.onExpire}
            reCaptchaKey={reCaptchaKey}
            shouldRenderSelectRecaptchaMsg={this.shouldRenderSelectRecaptchaMsg}
          />
        )}
        {this.shouldRenderOtpLoginFormCard() && (
          <OtpLoginFormCard
            companyTypeTabButton={this.companyTypeTabButton}
            companyType={companyType}
            selectCompanyType={this.selectCompanyType}
            toggleOtpLogin={this.toggleOtpLogin}
            onClickSendOtp={this.onClickSendOtp}
            handleEmailOrMobileChange={this.handleEmailOrMobileChange}
            emailOrMobileInput={emailOrMobileInput}
            shouldRenderCompanyTab={this.shouldRenderCompanyTab}
          />
        )}
        {this.shouldRenderOtpVerifyFormCard() && (
          <OtpVerifyFormCard
            companyTypeTabButton={this.companyTypeTabButton}
            companyType={companyType}
            selectCompanyType={this.selectCompanyType}
            handleChangeOtp={this.handleChangeOtp}
            otp={otp}
            backtoSendOtp={this.backtoSendOtp}
            maskInput={maskedInput}
            hasExpired={hasExpired}
            start_time={start_time}
            expire_time={expire_time}
            systemTime={systemTime}
            otpExpired={this.otpExpired}
            otpSignin={this.otpSignin}
            onSubmit={this.formSubmit}
            onClickReSendOtp={this.onClickReSendOtp}
            shouldRenderCompanyTab={this.shouldRenderCompanyTab}
          />
        )}
        {this.shouldRenderForgotPasswordFormCard() && (
          <ForgotPassword
            companyTypeTabButton={this.companyTypeTabButton}
            companyType={companyType}
            selectCompanyType={this.selectCompanyType}
            toggleForgotPassword={this.toggleForgotPassword}
            handleEmailChange={this.handleEmailChange}
            email={email}
            forgotPassword={this.forgotPassword}
            shouldRenderCompanyTab={this.shouldRenderCompanyTab}
            shouldEnableRecaptcha={this.shouldEnableRecaptcha}
            verifyCallback={this.verifyCallback}
            onExpire={this.onExpire}
            reCaptchaKey={reCaptchaKey}
          />
        )}
        {this.shouldRenderLoginWithSsoFormCard() && (
          <LoginWithSso
            companyTypeTabButton={this.companyTypeTabButton}
            companyType={companyType}
            selectCompanyType={this.selectCompanyType}
            toggleLoginWithSso={this.toggleLoginWithSso}
            handleEmailChange={this.handleEmailChange}
            email={email}
            // onSubmit={this.formSubmit}
            validateSSOUser={this.validateSSOUser}
            shouldRenderCompanyTab={this.shouldRenderCompanyTab}
          />
        )}
        {/* {this.shouldEnableRecaptcha() && <Fragment>
          {showTag &&
            <Recaptcha
              sitekey="6LcHtbwUAAAAAKkjbo7nNh9ajzF5GEHk9uC5skGG"
              render="explicit"
              verifyCallback={this.verifyCallback}
              onloadCallback={this.callback}
              expiredCallback={this.onExpire}
              key={reCaptchaKey}
            />}
          {this.shouldRenderSelectRecaptchaMsg() && <Fragment>
            <h6
              className='error-color m-0 fs-16'
            >
              Please select I'm not a robot
            </h6>
          </Fragment>}
          <br></br>
        </Fragment>} */}
        {
          show_checkbox === true &&
          <div
            className="fs-14 flex flex-center col-1"
            style={{ background: "linear-gradient(87deg, #597EF7 15.86%, #C4BEFE 124.08%)" ,marginTop:"-200px"}}
          >
            <div
              className="theme-color fBold flex flex-center pt-5 mb-40 tCenter "
              style={{
                background: "wheat",
                padding: "1rem",
                "border-radius": "5px",
                "margin-top": "1rem",
                zIndex:4
              }}
            >
              <AlertIcon className="wt-20 flex ht-20 alert-icon" />
              <div style={{ "padding-left": "5rem" }}>
                {
                  <Fragment>
                    <span className="error-color flex flex-center" style={{ fontSize: "16px" }}>
                      Your Previous Login / Session is still active and not closed properly.
                      To Logout previous sessions,
                      {<Fragment>
                        <a
                          onClick={this.forceSignIn}
                          style={{
                            color: "white",
                            "box-shadow": "0 0 5px 0 black",
                            padding: "0.25rem",
                            "margin-left": " 0.5rem",
                            "border-radius": "5px",
                            background: "green"
                          }}
                          className={cx('btnT2', {
                            disabledT1: this.shouldEnableRecaptcha() ? isUserAlreadyLoggedin : false
                          })}
                        >
                          Click Here...
                        </a>
                      </Fragment>}
                    </span>
                  </Fragment>}
                {<div className="error-color flex flex-center fBold mt-5" style={{ fontSize: "16px" }}>Note: Any unsaved data in previous sessions will be lost</div>}
              </div>
            </div>
          </div>
        }
        {
          otp_show_checkbox === true &&
          <div
            className="fs-14 flex flex-center col-1"
            style={{ background: "linear-gradient(87deg, #597EF7 15.86%, #C4BEFE 124.08%)", marginTop: "-200px" }}
          >
            <div
              className="theme-color fBold flex flex-center pt-5 mb-40 tCenter "
              style={{
                background: "wheat",
                padding: "1rem",
                "border-radius": "5px",
                "margin-top": "1rem",
                zIndex: 4
              }}
            >
              <AlertIcon className="wt-20 flex ht-20 alert-icon" />
              <div style={{ "padding-left": "5rem" }}>
                {
                  <Fragment>
                    <span className="error-color flex flex-center" style={{ fontSize: "16px" }}>
                      Your Previous Login / Session is still active and not closed properly.
                      To Logout previous sessions,
                      {<Fragment>
                        <a
                          onClick={this.forceotpSignin}
                          style={{
                            color: "white",
                            "box-shadow": "0 0 5px 0 black",
                            padding: "0.25rem",
                            "margin-left": " 0.5rem",
                            "border-radius": "5px",
                            background: "green"
                          }}
                          className={cx('btnT2', {
                            disabledT1: this.shouldEnableRecaptcha() ? isUserAlreadyLoggedin : false
                          })}
                        >
                          Click Here...
                        </a>
                      </Fragment>}
                    </span>
                  </Fragment>}
                {<div className="error-color flex flex-center fBold mt-5" style={{ fontSize: "16px" }}>Note: Any unsaved data in previous sessions will be lost</div>}
              </div>
            </div>
          </div>
        }
        <div className="footer flex flex-center ">
          <div className=" mt-10 mb-10 ml-15 mr-15 tCenter fBold curP" onClick={() => this.props.history.push('/infringementPolicy')}>IP & Infringement Policy</div>
          <div className=" mt-10 mb-10 ml-15 mr-15 tCenter fBold curP" onClick={() => this.props.history.push('/privacyPolicy')}>Privacy Policy</div>
          <div className=" mt-10 mb-10 ml-15 mr-15 tCenter fBold curP" onClick={() => this.props.history.push('/termsOfUse')}>Terms Of Use</div>
          <div className=" mt-10 mb-10 ml-15 mr-15 tCenter fBold curP" onClick={() => this.props.history.push('/liabilityDisclaimer')}>Liability Disclaimer</div>
          <div className=" mt-10 mb-10 ml-15 mr-15 tCenter fBold curP" onClick={() => this.props.history.push('/contactUs')}>Contact Us</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ authentication, common }) => {
  return {
    signinError: authentication.signin.error,
    isSubmitting: authentication.signin.isSubmitting || authentication.forgotPassword.isSubmitting,
    ssoConfigData: common.ssoConfigData || {}
  }
};
export default connect(mapStateToProps)(LoginForm);
